import BursonInvoicePendingAlertHtml from './templates/legacy.burson.invoice-pending.alert.html';
import BursonRequestInvoiceHtml      from './legacy.burson.request-invoice.html';

export function LegacyBursonInvoicesService (
  $uibModal,
  $q,
  $translate,
  confirm,
  sessionObjAPI,
  workshopAPI
) {
  const LegacyBursonInvoices = function () {
    this.origin  = sessionObjAPI.base().origin;
  };

  LegacyBursonInvoices.prototype.addItems = function (invoice) {
    const self = this;

    if (invoice.current_bursons_order) {
      return self.checkBursonAvailability(invoice)
      .then(() => self.createBursonOrder(invoice))
      .catch(() => self.invoicePendingAlert(invoice));
    }

    return self.createBursonOrder(invoice);
  };

  LegacyBursonInvoices.prototype.checkBursonAvailability = function (invoice) {
    return workshopAPI.get('/bursons/check_bursons_id_for_invoice', invoice.id)
    .then(requestId => {
      return requestId === '0' ? $q.reject($translate.instant('JS_SPACE.BURSON.ORDER_NOT_COMPLETED')) : $q.when(invoice);
    });
  };

  LegacyBursonInvoices.prototype.createBursonOrder = function (invoice) {
    return workshopAPI.get('/bursons/create_burson_order_for_invoice', invoice.id)
    .then(data => {
      return data.order.RequestStatus != 'FAIL' ?
        workshopAPI.get('/bursons/add_burson_request_id_to_invoice', [ data.order.RequestID, invoice.id ]) :
        $q.reject(`${data.order.RequestStatus} - ${data.order.ErrorReason}`);
    })
    .then(invoice => {
      return $uibModal.open({
        templateUrl: BursonRequestInvoiceHtml,
        controller : 'LegacyBursonRequestInvoiceCtrl',
        windowClass: 'lg-modal',
        resolve    : {
          invoice () {
            return invoice;
          },
          customer () {
            return workshopAPI.get('/customer', invoice.customer_id);
          }
        }
      }).result;
    });
  };

  LegacyBursonInvoices.prototype.getBursonItems = function (invoice) {
    const self = this;

    return self.checkBursonAvailability(invoice)
    .then(invoice => workshopAPI.get('/bursons/get_single_burson_order_for_invoice', [ invoice.current_bursons_order, invoice.id ]))
    .then(items => workshopAPI.post('/bursons/add_bursons_items_to_invoice', items, 'items'))
    .then(data => workshopAPI.get('/bursons/remove_burson_request_id_from_invoice', data))
    .then(() => $q.when($translate.instant('JS_SPACE.BURSON.BURSON_PARTS_ADDED')));
  };

  LegacyBursonInvoices.prototype.invoicePendingAlert = function (invoice) {
    return $uibModal.open({
      templateUrl: BursonInvoicePendingAlertHtml,
      controller : 'LegacyBursonRequestInvoiceCtrl',
      windowClass: 'lg-modal',
      resolve    : {
        invoice () {
          return invoice;
        },
        customer () {
          return workshopAPI.get('/customer', invoice.customer_id);
        }
      }
    }).result;
  };

  LegacyBursonInvoices.prototype.overwrite = function (invoice) {
    return workshopAPI.get('/bursons/remove_burson_request_id_from_invoice', invoice.id)
    .then(data => workshopAPI.get('/bursons/create_burson_order_for_invoice', data.id))
    .then(data => workshopAPI.get('/bursons/add_burson_request_id_to_invoice', [ data.order.RequestID, invoice.id ]))
    .then(invoice => {
      return $uibModal.open({
        templateUrl: BursonRequestInvoiceHtml,
        controller : 'LegacyBursonRequestInvoiceCtrl',
        windowClass: 'lg-modal',
        resolve    : {
          invoice () {
            return invoice;
          },
          customer () {
            return workshopAPI.get('/customer', invoice.customer_id);
          }
        }
      }).result;
    });
  };

  return LegacyBursonInvoices;
}
